import { Injectable, inject } from '@angular/core';
import { PlatformIdService } from '@ckmk/angular';
import { NavigationEnd, Router } from '@angular/router';
import type {
  FlowbiteInitCallback,
  FlowbiteInitCallbacks,
} from '@app/src/app/types/types';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FlowbiteService {
  private readonly platform = inject(PlatformIdService);
  private readonly router = inject(Router);

  private _flowbite: any;
  private _callbacks: FlowbiteInitCallbacks = [];

  public constructor() {}

  public load(callback: FlowbiteInitCallback): void {
    if (this.platform.isBrowser()) {
      if (!this._flowbite) {
        this._callbacks.push(callback);

        import('flowbite').then((flowbite) => {
          this._flowbite = flowbite;

          callback(this._flowbite);

          this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe({
              next: (event) => {
                this.runCallback();
              },
            });
        });
      } else {
        this._callbacks.push(callback);
      }
    }
  }

  public runCallback(): void {
    if (this._flowbite) {
      this._callbacks.forEach((cb) => cb(this._flowbite));
    }
  }
}
